/* eslint-disable @typescript-eslint/ban-types */
import { Injectable } from '@angular/core';
import { Paginator } from '@app/classes';
import { Employee } from '@app/models/employee/employee.model';
import { Salary } from '@app/models/employee/salary.model';
import { Table } from '@app/modules/table/classes/table.class';
import { AuthService } from '@app/services';
import {
    EmployeeCompensationTypeColumn,
    EmployeeNameNoBadgeColumn,
    EmployeeRateColumn,
    EmployeeSalaryEffectiveAtColumn,
    EmployeeSalaryEndsAtColumn,
    EmployeeSalaryStatusColumn,
    EmployeeVacationPayColumn,
} from './columns';

const pageSize = 5;

@Injectable()
export class CompensationHistoryReadOnlyTable extends Table {
    links = false;

    displayColumns = [
        new EmployeeNameNoBadgeColumn(),
        new EmployeeRateColumn(),
        new EmployeeSalaryStatusColumn(),
        new EmployeeSalaryEffectiveAtColumn(),
        new EmployeeSalaryEndsAtColumn(),
        new EmployeeCompensationTypeColumn(),
    ];

    constructor(
        protected auth: AuthService,
        private employee: Employee,
        private displayVacationPay: Boolean
    ) {
        super(auth);
        this.boot();
    }

    setColumns(): void {
        if (this.displayVacationPay) {
            this.displayColumns.push(new EmployeeVacationPayColumn());
        }

        this.columns = this.displayColumns;
    }

    setDataSource(): void {
        this.paginator = new Paginator(
            Salary.param('company', this.auth.company.id).param('employee', this.employee.id).limit(pageSize),
            {
                pageSize: pageSize,
            }
        );
    }
}
